const media = {
  phone: "650px",
  tablet: "1250px",
  computer: "1600px",
};

export default media;
